import { useHooks } from './useHooks';
import { DailyReportForWorkersView } from '../../components/parts/dailyReport/DailyReportForWorkersView';
import { DailyReportForWorkersMessageView } from '../../components/parts/dailyReport/DailyReportForWorkersMessageView';
import LoadingComponent from '../../components/LoadingComponent';

export const DailyReportForWorkersPage: React.FC = () => {
  const { isLoading, message, showMessage, construct, siteProcessList } =
    useHooks();
  return (
    <>
      {isLoading && <LoadingComponent />}
      {!isLoading && (
        <>
          {message !== '' && (
            <DailyReportForWorkersMessageView message={message} />
          )}
          {message === '' && (
            <DailyReportForWorkersView
              construct={construct}
              siteProcessList={siteProcessList}
              showMessage={showMessage}
            />
          )}
        </>
      )}
    </>
  );
};
